import React from 'react';
import useBootstrapSize from '../../../hooks/useBootstrapSize';
import TableMaterial from '@mui/material/Table';

export default function Table({ children, stickyHeader }) {
  const { sizeComponent } = useBootstrapSize();

  return (
    <TableMaterial stickyHeader={stickyHeader} size={sizeComponent}>
      {children}
    </TableMaterial>
  );
}
